module.exports = __webpack_public_path__ + "od-filter-lines-icon-desktop-white/od-filter-lines-icon-desktop-white-ec8e5c013251c59ad9b345ff0c7a0939.svg";